module.exports = __webpack_public_path__ + "r-v3/img/screen_gray.6bdf5e6e.svg";